/*
 * Parklio Bay Access gating for the console (DRI-2874), mirroring qrFeature.js.
 * Unlike QR — where mere presence of the row is the flag — Parklio carries a
 * configuration payload, so the feature is ON only when a row exists for the
 * Parklio feature AND provider AND its configuration.enabled is true. Matching the
 * provider alongside the feature name keeps this in lockstep with the API gate
 * (isParklioEnabledForInstallation / getParklioConfigForFacility, which key on the
 * same feature name, provider, and configuration.enabled).
 */
export const PARKLIO_BAY_ACCESS_FEATURE = "Parklio Bay Access";
export const PARKLIO_PROVIDER = "Parklio";

function parseConfiguration(configuration) {
  if (!configuration) return null;
  if (typeof configuration === "string") {
    try {
      return JSON.parse(configuration);
    } catch {
      return null;
    }
  }
  if (typeof configuration === "object") return configuration;
  return null;
}

export function isParklioBayAccessEnabled(facility) {
  const record = facility?.featureFacilityProviderConfigurations?.find(
    (item) =>
      item?.feature?.name === PARKLIO_BAY_ACCESS_FEATURE &&
      item?.provider?.name === PARKLIO_PROVIDER,
  );
  return parseConfiguration(record?.configuration)?.enabled === true;
}
